module.exports = __webpack_public_path__ + "static/bb-logo-c6c1ec243c2543ebbab1ff302ec82d31.svg";